import "./App.css";
import Navbar from "./Components/Navbar/Navbar";
import Work from "./Components/Work/Work";
import ScribbleLine from "./Components/ScribbleLine/ScribbleLine";
import About from "./Components/About/About";
import Contact from "./Components/Contact/Contact";
import Footer from "./Components/Footer/Footer";
import React, { useState, useEffect } from "react";

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timeout = setTimeout(() => setIsLoading(false), 2000);
    return () => clearTimeout(timeout);
  }, []);
  return (
    <div className="App">
      <div
        id="preloader"
        style={{ display: isLoading ? "block" : "none" }}
      ></div>
      <Navbar />
      <Work />
      <ScribbleLine />
      <About />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
